export class Settings {
  maxLobbyCarsPerUnit = 0;
  authToDateUnlimitedEnable = true;
  authCarEnable = true;
  signatureRequiredForPackagePickup = true;
  carRequestEnabled = false;
  discoverEnabled = false;
}